import { useQuery, useSuspenseQuery } from '@tanstack/react-query'
import { useTranslation } from 'react-i18next'

import { bulletinSchema } from '../../../common/validations'
import { API_ENDPOINTS } from '../../../common/apiEndpoints'

import { get } from 'api/apiClient'
import { Language, toSupportedLanguage } from 'i18n/i18n'

const params = (contractUuid: string, bulletinUuid: string, lang: Language) => {
  const basePath = API_ENDPOINTS.BULLETIN.replace(
    ':contractUuid',
    contractUuid
  ).replace(':bulletinUuid', bulletinUuid)

  const searchParams = new URLSearchParams({ language: lang })
  const path = `${basePath}?${searchParams.toString()}`

  return {
    cacheTime: 59000,
    queryKey: ['bulletin', contractUuid, bulletinUuid, lang],
    queryFn: async () => {
      return get(path, bulletinSchema)
    },
  }
}

export const useAPIGetBulletin = (
  contractUuid: string,
  bulletinUuid: string,
  languageOverride?: Language
) => {
  const { i18n } = useTranslation()

  return useQuery(
    params(
      contractUuid,
      bulletinUuid,
      languageOverride ?? toSupportedLanguage(i18n.resolvedLanguage)
    )
  )
}

export const useAPIGetBulletinSuspense = (
  contractUuid: string,
  bulletinUuid: string,
  languageOverride?: Language
) => {
  const { i18n } = useTranslation()

  return useSuspenseQuery(
    params(
      contractUuid,
      bulletinUuid,
      languageOverride ?? toSupportedLanguage(i18n.resolvedLanguage)
    )
  )
}
